export const dataLibC = [{
  word: 'chat',
  partOfSpeech: 'N',
  definition: ['cat'],
  egSentenceKw: 'Chyen ka kouwi dèyè chat.',
  egSentenceEn: 'Dogs chase cats.',
  synonym: ['tig'],
  antonym: [null],
  etymology: '[< Fr. chat]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'chèz',
  partOfSpeech: 'N',
  definition: ['chair'],
  egSentenceKw: 'La ni kat chèz èk kat tab.',
  egSentenceEn: 'There are four tables and chairs.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. chaise]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'chimiz',
  partOfSpeech: 'N',
  definition: ['shirt'],
  egSentenceKw: 'I ni on chimiz wouj.',
  egSentenceEn: 'He has a red shirt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. chemise]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'choson',
  partOfSpeech: 'N',
  definition: ['sock'],
  egSentenceKw: 'Ban mwen choson-an pou mwen mété an pyé mwen.',
  egSentenceEn: 'Give me the sock for me to put on my foot.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. chausson]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'cho',
  partOfSpeech: 'ADJ',
  definition: ['hot'],
  egSentenceKw: 'I ka fè cho jòdi-a.',
  egSentenceEn: 'It\'s hot today.',
  synonym: [null],
  antonym: ['fwet'],
  etymology: '[< Fr. chaud]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'chay',
  partOfSpeech: 'N',
  definition: ['load'],
  egSentenceKw: 'I ka pòté an gwo chay lou asou tèt li.',
  egSentenceEn: 'She is carrying a big, heavy load on her head.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. charrier]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'chéd',
  partOfSpeech: 'N',
  definition: ['shelter', 'shed', 'lean-to'],
  egSentenceKw: 'Yo konblé an chéd-la paski yo pa té vlé lapli-a mouyé yo.',
  egSentenceEn: 'They crowded in the shelter because they didn\'t want the rain to get them wet.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. shade]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'chlen',
  partOfSpeech: 'N',
  definition: ['shilling', '24 cents (often rounded off to 25 cents)'],
  egSentenceKw: 'Abwézan yo ka vann yon pen pou yon chlen dé sou.',
  egSentenceEn: 'Nowadays they sell one bread for twenty-five cents.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. shilling]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'chanjmandè',
  partOfSpeech: 'N',
  definition: ['a change of air', 'atmosphere', 'setting', 'location'],
  egSentenceKw: 'Si ou alé Anglitè anlè vakans, chanjmandè-a kay bon pou\'w.',
  egSentenceEn: 'If you go to England on vacation, the change of setting will be good for you.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. changement d\'air]',
  dialect: '🇱🇨',
  variant: [null],
},
];
